import React, { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { Box, Button, Typography, Paper } from "@mui/material";

const SignatureBox = ({ onSave }) => {
  const sigRef = useRef();
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);

  const clear = () => {
    sigRef.current.clear();
    setTrimmedDataURL(null);
  };

  const save = () => {
    const data = sigRef.current.getCanvas().toDataURL("image/png");
    setTrimmedDataURL(data);

    if (onSave) onSave(data);
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
        Firma aquí:
      </Typography>

      <Paper
        elevation={2}
        sx={{
          width: "30em",
          height: 200,
          borderRadius: 2,
          border: "2px dashed #ccc",
          overflow: "hidden",
        }}
      >
        <SignaturePad
          ref={sigRef}
          canvasProps={{
            width: 500,
            height: 200,
            style: { backgroundColor: "#fff", width: "100%" },
          }}
        />
      </Paper>

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button variant="outlined" color="error" onClick={clear}>
          Limpiar
        </Button>
        <Button variant="contained" color="primary" onClick={save}>
          Guardar firma
        </Button>
      </Box>

      {trimmedDataURL && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2">Vista previa:</Typography>
          <img
            src={trimmedDataURL}
            alt="Firma"
            style={{ width: 200, border: "1px solid #ddd", marginTop: 8 }}
          />
        </Box>
      )}
    </Box>
  );
};

export default SignatureBox;
